var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file-type-zip",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.25,
    height: 30,
    viewBox: "0 0 23.25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M16.483,0H.791C.354,0,0,.351,0,1.032V29.464c0,.185.354.536.791.536H22.459c.437,0,.791-.351.791-.536V6.952c0-.373-.05-.493-.139-.581L16.819.138A.48.48,0,0,0,16.483,0Z",
    fill: "#f2f2e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M22.349.108V6.455h6.407Z",
    transform: "translate(-5.587 -0.027)",
    fill: "#d9d7ca"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M22.459,36.964H.791A.787.787,0,0,1,0,36.181V27.857H23.25v8.323A.787.787,0,0,1,22.459,36.964Z",
    transform: "translate(0 -6.965)",
    fill: "#fab85b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M12.208,30.66v.71L9.637,35.23l-.146.117h2.717v.71H8.619v-.71l2.571-3.86.154-.117H8.619v-.71Z",
    transform: "translate(-2.155 -7.665)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M15.967,36.058h-.894v-5.4h.894Z",
    transform: "translate(-3.769 -7.665)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M18.931,36.058h-.879v-5.4H19.6a2.181,2.181,0,0,1,.681.11,1.853,1.853,0,0,1,.6.329,1.721,1.721,0,0,1,.432.531,1.471,1.471,0,0,1,.165.7,1.914,1.914,0,0,1-.139.744,1.554,1.554,0,0,1-.388.56,1.75,1.75,0,0,1-.6.351,2.311,2.311,0,0,1-.776.124h-.652v1.948Zm0-4.731v2.139h.806a.957.957,0,0,0,.319-.055.8.8,0,0,0,.289-.179.877.877,0,0,0,.212-.348,1.648,1.648,0,0,0,.08-.553,1.5,1.5,0,0,0-.036-.3.878.878,0,0,0-.15-.329.889.889,0,0,0-.319-.264,1.184,1.184,0,0,0-.542-.106h-.659Z",
    transform: "translate(-4.513 -7.665)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M14.643,13.929V12.857h1.071V11.786H14.643V10.714h1.071V9.643H14.643V8.571h1.071V7.5H14.643V6.429h1.071V5.357H14.643V4.286H13.571V5.357H12.5V6.429h1.071V7.5H12.5V8.571h1.071V9.643H12.5v1.071h1.071v1.071H12.5v1.071h1.071v1.071H11.429v2.679a2.679,2.679,0,1,0,5.357,0V13.929Zm1.071,2.679a1.607,1.607,0,1,1-3.214,0V15h3.214Z",
    transform: "translate(-2.857 -1.071)",
    fill: "#bfb9b0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M14.107,21.071h1.071a.536.536,0,0,0,0-1.071H14.107a.536.536,0,0,0,0,1.071Z",
    transform: "translate(-3.393 -5)",
    fill: "#bfb9b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.f5b9d84920ce13953c51a299bf6269f0.svg";
export { ForwardRef as ReactComponent };